package views.coletor

import androidx.compose.runtime.*
import ffButton0
import ffButtonDiv
import ffEspVerticalMil
import ffSpan
import kotlinx.browser.document
import kotlinx.dom.clear
import lbTitulo
import model.Notas
import ffMsgAviso
import org.jetbrains.compose.web.attributes.onSubmit
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.HTMLDivElement
import utils.*
//import utils.ff.Companion.giClick
import utils.ff.Companion.println0
import views.componentes.*

class col002 {

    private val _t = "col002" //consulta ordens
    private var onot: Notas = Notas()
    private var sOf = ""
    private var loino: List<Notas>? = null

    fun show(_sOf: String? = "") {

        if (_sOf != null)
            sOf = _sOf

        lbTitulo!!.innerText = "002 - Consulta ordens"

        val htmlDiv1 = document.getElementById("htmlDiv1") as HTMLDivElement
        htmlDiv1.clear()

        renderComposable(rootElementId = "htmlDiv1") {
            body()
            //if (lemp5 != null && lemp5!!.count() > 0)
            //body1(lemp5!!)
        }
    }

    @Composable
    fun body() { //675890
        Div(attrs = { classes("form-group", "dlg-pad-top-5") }) {

            val _tela = remember { mutableStateOf("codigo") }

            Form(action = "#", attrs = { onSubmit { it.preventDefault() } })
            {
                ffMsgAviso("")

                val _codigo = remember { mutableStateOf(gsInput(_t, _id = "$_t._codigo")) }
                //_codigo.tipo("S")
                if (!sOf.equals("")) {
                    println0("of99  = $sOf")
                    _codigo.text(sOf)
                    //_codigo.atualizar()
                    //_tela.value = "nota"
                    //_codigo.atualiza()
                    sOf = ""
                }
                //ffInput1Acao("Quantidade", _inot_qtdcont, "N", 0, 33, _acao = { sClick.value = "ok" })
                //val _codigo = remember { mutableStateOf("675890") }
                //ffInputKey("Chave da NFe ou número da OF", _codigo, "N", 0, 100, _key, false)
                //ffInput1Acao("Chave da NFe ou número da OF", _codigo, "N", 0, 100, _acao = { onkeyPress_produto(_inProduto) })
                //Div({ classes("input-group-append") }) {
                ffInput44("Chave da NFe ou número da OF", _codigo, "NS", 0, 100, false, {}, {})
                if (_tela.value.equals("codigo")) {
                    SideEffect { _codigo.setFocusSimples(true) }
                    _tela.value = ""
                    if (!_codigo.text().equals("")) {
                        gsKey = "Enter"
                        _codigo.key("Enter")
                    }
                }
                _codigo.onKeyPressENTER { o ->
                    Notas().consultarNFe(_codigo.text()) { onota ->
                        onot = onota

                        _tela.value = "nota"
                        //ffPegaCampo(_tela.value,"!01")
                        _tela.value
                        _codigo.atualizar()
                        //println0("zuza2 mandou atualizar o código")
                        if (onot.NOT_OF == 0)
                            ffMsgAviso("OF não encontrada")
                    }
                }
                //ffInput1("Chave da NFe ou número da OF", _codigo, "NS", 0, 100, false)
                //}
//                onkeyPress_codigo(_codigo.text().ffVsi(), _codigo.key0()) {
//                    if (onot.NOT_OF != 0) {
//                        _tela.text("nota", true)
//                    }
//                }

                //println0("zuza5 " + _tela.value)
                if (_tela.value.contains("nota")) { // && onot != null) {
                    //println0("zuza3 aquio ${onot.NOT_FINALIDADE} ${onot.NOT_DTVIG.ffDdBr(4)} ${onot.NOT_QTCONF}")

                    Div({ classes("form-group", "dlg-div-detalhes") }) {
                        Div({ classes("input-group") }) {
                            ffSpan("Lote: ${onot.NOT_FATLOTE}", _width = 50)
                            ffSpan("Entrega: ${onot.NOT_ENTRSEQUENCIA}", _width = 30)
                            ffSpan("Volumes: ${onot.NOT_QTVOLUMES}", _width = 20, _align = "right")
                        }
                        Div({ classes("input-group") }) {
                            ffSpan("Região para entrega: ${onot.REG_DESCR00}", _width = 50)
                            ffSpan("Motorista: ${onot.MOTO_NOME00}", _width = 50, _align = "right")
                        }

                        Hr({ classes("dlg-hr") })
                        ffSpan("Data da nota - ${onot.NOT_DTEMI.ffDdBr(2)}")
                        Div({ classes("input-group") }) {
                            ffSpan("Finalidade: ${onot.NOT_FINALIDADE}", _width = 40)
                            ffSpan("NF: ${onot.NOT_NRNOTA}", _width = 30)
                            ffSpan("OF: ${onot.NOT_OF}", _width = 30, _align = "right")
                        }

                        Hr({ classes("dlg-hr") })
                        ffSpan("Cliente: ${onot.NOT_CLIENTE.toString().ffZeroLeft(6)} - ${onot.NOT_RAZAO}")
                        ffSpan("Chave: ${onot.NOT_CHAVEACESSO}")
                    }

                    val _inVolumes = remember { mutableStateOf(gsInput(_t)) }
                    Div({ classes("input-group-append") }) {
                        ffInput1("Volumes", _inVolumes, "N", 99999, 50)
                        ffButtonDiv(
                            "Confirmar volumes",
                            {
                                onClickVolumes(
                                    _inVolumes.text().ffVsi()
                                ) { o -> _codigo.text(""); _inVolumes.text("") }
                            },
                            50
                        )
                    }

//                    Div({ classes("input-group-append") }) {
                    Div() {
                        ffButton0("Abrir", { onClickAbrir() }, 100)
                    }
                    ffEspVerticalMil(3)

                }

                val _not_lote = remember { mutableStateOf(gsInput(_t)) }
                val _not_identrega = remember { mutableStateOf(gsInput(_t)) }
                var sEnvio = ""

                val _table1Controler = remember { mutableStateOf(gsInput(_t)) } //limpar o value após o uso
                Div({ classes("input-group-append") }) {
                    ffInput1("Número lote", _not_lote, "N", 999999, 50)
                    _not_lote.onKeyPressENTER {
                        abrirGrid("${_not_lote.text()}/L", _table1Controler)
                    }
//                    if (_not_lote.key().equals("Enter")) {
//                        abrirGrid("${_not_lote.text()}/L", _table1Controler)
//                    }

                    ffInput1("Número entrega", _not_identrega, "N", 999999, 50, false)
                    _not_identrega.onKeyPressENTER {
                        abrirGrid("${_not_identrega.text()}/E", _table1Controler)
                    }

                }

                if (onot.NOT_OF != 0 && onot.NOT_DTSEPAFIM.ffNull()) {
                    Div() {
                        ffButton0("Concluir conferência", {
                            val sSQL = "update notas set not_dtsepafim = GetDate() where not_empresa = ${onot.NOT_EMPRESA} and not_of = ${onot.NOT_OF}"
                            Service().postGen(sSQL.asDynamic(), "${ff.gsDom1}/delphi/postupdate/026") { objReturn ->
                                if (objReturn.PAD_CODIGO == 200) {
                                    println0("Conferência concluída")
                                    //principalCOL().ffNavePage("col002", onot.NOT_OF.toString())
                                    show(onot.NOT_OF.toString())
                                }
                            }
                        }, 100)
                    }
                }

                Div() {
                    //abrirGrid(sEnvio, _table1ClickControler)
                    //val _table1Click = remember { mutableStateOf("") }

                    if (!_table1Controler.json().equals("")) {
                        //println0("esta formando a table de novo")
                        //println0("zuza65 " + _table1ClickControler.value)
                        val lcon = ArrayList<table1>()
                        lcon.add(table1().add(10, "S", "N", "NOT_QTCONF       ", "Conf"))
                        lcon.add(table1().add(10, "S", "N", "NOT_ENTRSEQUENCIA", "Ordem"))
                        lcon.add(table1().add(60, "S", "N", "OO_CLIENTE       ", "Cliente"))
                        lcon.add(table1().add(10, "N", "N", "NOT_QTVOLUMES    ", "Volumes"))
                        lcon.add(table1().add(30, "N", "N", "NOT_OF           ", "OF"))

                        //println0("zuza12345 ${_table1Click.value}")
                        //println0("zuza12345 ${giClick}")

                        table1().ffTable1(
                            lcon,
                            //_table1Click = _table1Click,
                            _table1Controler = _table1Controler,
                            _tbTipo = "Black"
                        )
                    }
                    //if (!_table1Controler.clickObj().equals("")) {
                    //println0("zuza1234 ${_table1Controler.clickObj()} giClick=$giClick")
                    //if (!_table1Click.value.equals("")) {
                    //if (giClick != -1) {

                    if (loino != null && _table1Controler.clickObj() >= 0) {
                        onot = loino!!.get(_table1Controler.clickObj())
                        sOf = onot.NOT_OF.toString()
                        if (!_codigo.text().equals(""))
                            _codigo.text("")
                        else
                            _codigo.text(sOf)
                        _codigo.setFocus("true", true)
                        _codigo.keySet("Enter")
                        _tela.value = "codigo"
                        _table1Controler.clickObjLimpar()
                    }

                }

                //if (_table1Controler.value.equals("")) {
                //println0("_tableClick = " + _table1Controler.value)
                //}
            }

        }
    }

//******************************************************************************* INICIO DOS EVENTOS

    //@Composable
    private fun abrirGrid(_envio: String, _table1ClickControler: MutableState<String>): Unit {

        println0("abrirGrid " + _envio)
        if (!_envio.equals("")) {
            Notas().getNota00("notas/018/${ff.giEmpresa}/$_envio") { o ->
                loino = o
                println0(loino)
                _table1ClickControler.json(JSON.stringify(loino).ffJsonParse(false))
                //_table1ClickControler.json(loino.asDynamic().toString().ffJsonParse(false))
            }
        }

    }

    private fun onClickVolumes(_volume: Int, callback: (Boolean) -> Unit): Boolean {

        println0("onClickVolumes $_volume")
        onot.NOT_QTVOLUMES = _volume
        Service().postGen(onot.asDynamic(), "${ff.gsDom1}/notas/016/qtvolumes") { objReturn ->
            if (objReturn.PAD_CODIGO.compareTo(200) == 0) {
                //ff.println0("Gravado")
                ffMsgAviso("Gravado")
                sOf = onot.NOT_OF.toString()
                callback(true)
            }
        }
        return true
    }

    private fun onClickAbrir(): Boolean {

        println0("onClickAbrir")

        principalCOL().ffNavePage("col003", "[" + JSON.stringify(onot).ffJsonParse(true) + "]")

        /*
        Service().postGen(onot.asDynamic(), "${ff.gsDom1}/notas/016/qtvolumes") { objReturn ->
            if (objReturn.PAD_CODIGO.compareTo(200) == 0) {
                //ff.println0("Gravado")
                msgAviso("Gravado")
            }
        }
        */
        return true
    }

//********************************************************************************* INICIO DAS FUNCOES


}
